export default function MenuMessagesIcon({
  className,
}: {
  className?: string;
}) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M20.2027 15.0281C20.1559 14.8594 20.259 14.625 20.3574 14.4562C20.3875 14.406 20.4204 14.3575 20.4559 14.3109C21.2979 13.0598 21.7482 11.5862 21.7496 10.0781C21.7637 5.75625 18.1168 2.25 13.6074 2.25C9.67461 2.25 6.39336 4.92656 5.62461 8.47969C5.5096 9.00632 5.45146 9.54377 5.45117 10.0828C5.45117 14.4094 8.95742 18.0094 13.4668 18.0094C14.184 18.0094 15.1496 17.7937 15.6793 17.6484C16.209 17.5031 16.734 17.3109 16.8699 17.2594C17.0093 17.2068 17.1569 17.1798 17.3059 17.1797C17.4683 17.1791 17.6293 17.2109 17.7793 17.2734L20.4371 18.2156C20.4954 18.2403 20.557 18.2561 20.6199 18.2625C20.7194 18.2625 20.8148 18.223 20.8851 18.1527C20.9554 18.0823 20.9949 17.987 20.9949 17.8875C20.9916 17.8446 20.9838 17.8022 20.9715 17.7609L20.2027 15.0281Z"
        stroke="black"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M3.11534 10.875C2.50054 11.9795 2.20314 13.2325 2.256 14.4954C2.30886 15.7584 2.70993 16.9822 3.41487 18.0314C3.52315 18.195 3.58409 18.3216 3.56534 18.4064C3.54659 18.4913 3.00612 21.3066 3.00612 21.3066C2.99312 21.3724 2.99805 21.4406 3.0204 21.5039C3.04274 21.5673 3.08169 21.6234 3.13315 21.6666C3.20183 21.7213 3.28722 21.7507 3.37503 21.75C3.42195 21.7501 3.46839 21.7406 3.51143 21.7219L6.14628 20.6906C6.32762 20.6191 6.52992 20.6225 6.70878 20.7C7.59659 21.0459 8.57815 21.2625 9.56018 21.2625C10.878 21.2639 12.1726 20.9163 13.3125 20.2552"
        stroke="black"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
    </svg>
  );
}
